import { render, staticRenderFns } from "./StoreSavingsBadge.vue?vue&type=template&id=65e630a4&scoped=true&"
import script from "./StoreSavingsBadge.vue?vue&type=script&lang=js&"
export * from "./StoreSavingsBadge.vue?vue&type=script&lang=js&"
import style0 from "./StoreSavingsBadge.vue?vue&type=style&index=0&id=65e630a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e630a4",
  null
  
)

export default component.exports